import React, { useState, useEffect } from 'react';
import ModelSelection from './ModelSelection';

const CreatePool = ({ onBack, poolId = null, pool = {}, pools = [] }) => {
  
  return (
    <ModelSelection onBack={onBack} poolId={poolId} pool={pool} pools={pools} isPoolCreation={true}/>
  );
};

export default CreatePool;
